import { render, staticRenderFns } from "./PainSpotArticle.vue?vue&type=template&id=8d9cd7be&scoped=true"
import script from "./PainSpotArticle.vue?vue&type=script&lang=js"
export * from "./PainSpotArticle.vue?vue&type=script&lang=js"
import style0 from "./PainSpotArticle.vue?vue&type=style&index=0&id=8d9cd7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9cd7be",
  null
  
)

export default component.exports